export default {
  currentCustomer: null,
  customersList: [],
  customersTotal: 0
};
